function validIntNumberInput(number, min, max){
    var valid = false;
    if(parseInt(number) != 0){
        var regex = /^\d*$/;
        valid = regex.test(number);

        if(valid){
            valid = (parseInt(number) >= min && parseInt(number) <= max)
        }
    }

    return valid;
}

function validFloatNumberInput(number, min, max, decimal){
    if(decimal == undefined) decimal = 1;
    var valid = false;
    number = number.replace(",", ".");
    if(number != ""){
        var regex = /^\d*\.{0,1}\d{0,1}$/;
        if(decimal == 2){
            regex = /^\d*\.{0,1}\d{0,2}$/;
        }
        valid = regex.test(number);

        if(valid){
            valid = (parseFloat(number) >= min && parseFloat(number) <= max)
        }
    }

    return valid;
}

function clearFieldValidaitonClass($field){
    $field.removeClass("is-invalid");
    $field.parents(".js-input_group").find(".input-group").removeClass("is-invalid").addClass("is-valid");
    $field.parents(".js-input_group").removeClass("is-invalid").removeClass("is-valid");
    $field.parents(".js-input_group").siblings(".js-invalid_group").hide();
}

function setFieldValidaitonClass($field, valid){
    if(valid){
        $field.removeClass("is-invalid");
        $field.parents(".js-input_group").find(".input-group").removeClass("is-invalid").addClass("is-valid");
        $field.parents(".js-input_group").removeClass("is-invalid").addClass("is-valid");
        $field.parents(".js-input_group").siblings(".js-invalid_group").hide();
    }else{
        $field.addClass("is-invalid");
        $field.parents(".js-input_group").find(".input-group").addClass("is-invalid").removeClass("is-valid");
        $field.parents(".js-input_group").addClass("is-invalid").removeClass("is-valid");
        $field.parents(".js-input_group").siblings(".js-invalid_group").show();
    }
}